import { Button, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ColumnBaseProps } from '../types';

const SettingsColumn: React.FC<ColumnBaseProps> = ({
  record,
  editFormStore,
}) => {
  const { t } = useTranslation();
  const { handleSetupButtonClick, isFieldSetupDisabled, formStore } =
    editFormStore;

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      handleSetupButtonClick(record);
    },
    [handleSetupButtonClick, record]
  );

  const disabledCondition = isFieldSetupDisabled({
    dataType: record.catalogField.dataType,
    fillingMethod: record.formField.fillingMethod,
    setupRequired: record.catalogField.setupRequired,
    importEditable: record.formField.importEditable,
  });

  const buttonNode = React.useMemo(() => {
    return (
      <Button
        ghost={!disabledCondition}
        disabled={disabledCondition}
        type={disabledCondition ? 'default' : 'primary'}
        onClick={handleClick}
      >
        {t('common.setup')}
      </Button>
    );
  }, [disabledCondition, handleClick, t]);

  if (!formStore.saved) {
    return (
      <Tooltip title={t('editForm.settingsTooltip')} placement="top">
        {buttonNode}
      </Tooltip>
    );
  }

  return buttonNode;
};

export default observer(SettingsColumn);
